import { CLEAR_SUPPORT_TICKET_REQUEST } from "../../CONSTANTS";

export default function clearSupportTicketRequest() {
  return {
    type: CLEAR_SUPPORT_TICKET_REQUEST,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/tickets/clearSupportTicketRequest.js